<template>
  <div>
    <div class="footer" id="contact_Us">
      <div class="con">
        <div class="logobox">
          <img src="../img/logo.png" class="logo" alt="" />
        </div>
        <div class="txt">
          <div class="wow animated fadeInDown">
            <h3 class="title">联系我们</h3>
            <span class="tip">CONTACT US</span>
          </div>
          <div class="rx wow animated fadeInDown">
            <p>北京大昱丰科技有限公司</p>
            <p>联系电话：400-666-1839</p>
            <p>联系地址：北京市丰台区海鹰路5号</p>
            <p class="beianTxt">
              <span>©Copyright 2023-{{ currentYear }} 版权所有</span>
              <a
                target="_blank"
                href="https://beian.miit.gov.cn/?spm=5176.20960838.J_9220772140.60.5fb928684dOPHa#/Integrated/index"
              >
                <span> {{ beian_num }}</span>
              </a>
            </p>
          </div>
        </div>
        <div class="ewm wow animated fadeInDown">
          <img :src="wximg" alt="" />
          <p>微信公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "../utils/bus";
export default {
  name: "foot",
  components: {},
  data() {
    return {
      wximg: require("../img/ercode.png"),
      beian_num: "京ICP备2023015666号",
      currentYear: new Date().getFullYear(),
    };
  },
  mounted() {
    Bus.$on("navId", (data) => {
      //使用summ的值
      let Id = data;
      let toElement = document.getElementById(data);
      //锚点存在跳转
      if (Id) {
        toElement.scrollIntoView();
      }
    });
  },
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  height: 260px;
  background: #eaf6ff;
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  .con {
    display: flex;

    .logobox {
      padding-top: 35px;
      margin-right: 150px;
    }
  }

  .beianTxt {
    a {
      color: #000;
    }
  }

  .txt {
    width: 730px;
    display: flex;
    flex-direction: column;
    color: #000;
    text-align: left;
    font-size: 14px;
    margin-top: 40px;
    float: left;

    .title {
      font-size: 24px;
    }

    .tip {
      font-size: 16px;
    }

    .rx {
      margin-top: 30px;

      .beian {
        margin-top: 30px;
      }
    }

    .list {
      color: #000;

      li {
        position: relative;

        &:after {
          content: "";
          width: 2px;
          height: 15px;
          background-color: #fff;
          position: absolute;
          top: 4px;
          right: -15px;
        }

        &:nth-child(5):after {
          width: 0px;
        }

        float: left;
        margin-right: 30px;

        a {
          color: #000;
          font-size: 16px;
        }
      }
    }
  }

  .ewm {
    margin-top: 40px;

    img {
      margin-top: 30px;
      width: 120px;
      height: 120px;
    }

    p {
      text-align: center;
      font-size: 16px;
      color: #000;
      margin-top: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue